<template>
  <tr>
    <td :class="{ 'info__title': title }">
      {{ label }}
    </td>
    <td :class="{ 'info__title': title }">
      {{ value }}<slot />
    </td>
  </tr>
</template>

<script>
export default {
    name: 'BaseTableRow',
    props: {
        title: { type: Boolean, default: false },
        label: { type: String, default: '' },
        value: { type: String, default: '' },
    },
};
</script>
